import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CorreoRequest } from '../../models/correo/correo-request.model';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root',
})
export class CorreoService {
  // private apiUrl = environment.EXTERNAL.serviceCorreo; 
  private apiUrl = `${environment.HOST}${URL_MAP.EXTERNAL.serviceCorreo}`;
  constructor(private http: HttpClient) {}

  enviarCorreo(correo: CorreoRequest): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(this.apiUrl, correo, { headers });
  }
}
